import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Layout from '../layouts/layout';
import Home from '../views/app/pages/dashboard';
import SignIn from '../views/app/pages/auth/signIn';
import PasswordChange from '../views/app/pages/auth/forcePasswordChange';
import ProtectedRoute from './ProtectedRoute';
import NotAuthorized from '../views/app/pages/errors/NotAuthorized';
import UserManagement from '../views/app/pages/userMangement';
import MyView from '../views/app/pages/myView';
import TwoFactorAuth from "../views/app/pages/2factorAuth"
import CashTransaction from "../views/app/pages/transaction/cash/viewTransaction"
import StockTransaction from "../views/app/pages/transaction/stock/viewTransaction"
import RealEstateTransaction from "../views/app/pages/transaction/realEstate/viewTransaction"
import LuxaryAssetsTransaction from "../views/app/pages/transaction/luxaryAsset/viewTransaction"
import CompanyTransaction from "../views/app/pages/transaction/company/viewTransaction"
import WealthView from "../views/app/pages/wealthView"




import ViewGroups from "../views/app/pages/Groups/viewGroups"
import ViewLegacy from "../views/app/pages/legacy/viewLegacy"



function Router() {
  const browserRouter = createBrowserRouter([
    { path: '/SignIn', element: <SignIn /> },
    { path: '/password-change', element: <PasswordChange /> },
    { path: '/not-authorized', element: <NotAuthorized /> },
    {
      path: '/authentication',
      element: (
          <TwoFactorAuth />
      ),
    },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'user-management',
          element: (
            <ProtectedRoute allowedRoles={['admin']}>
              <UserManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: 'my-view',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <MyView />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-cash-transaction',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <CashTransaction />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-stock-transaction',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <StockTransaction />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-real-estate-transaction',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <RealEstateTransaction />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-luxury-asset-transaction',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <LuxaryAssetsTransaction />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-group',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <ViewGroups />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-legacy',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <ViewLegacy />
            </ProtectedRoute>
          ),
        },
        {
          path: 'view-company-transaction',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <CompanyTransaction />
            </ProtectedRoute>
          ),
        },{
          path: 'wealth-view',
          element: (
            <ProtectedRoute allowedRoles={['user']}>
              <WealthView />
            </ProtectedRoute>
          ),
        },
        
      ],
    },
  ]);

  return <RouterProvider router={browserRouter} />;
}

export default Router;
